const PushNotificationIOS = {
  setApplicationIconBadgeNumber: (badgeCount: number) => {
    return badgeCount;
  },
};

export { PushNotificationIOS };
